import { useEffect, useState } from "react";
import { MwButton, MwSpinnerButton } from "../../ui";
import { useCurrent, useFetch, usePut } from "../../../hooks";
import { langObjType, objLangTextHandler, LangArrayToObjKeyValue } from "../../../utils/global";
import CardHeadeWithActions from "../../ui/CardHeadeWithActions";
import GroupForm from "./GroupForm";
import { useTranslation } from "react-i18next";
import { invalidateFetchCache } from "../../../hooks/useFetch";

const EditGroup = ({ id, setMode }) => {
  const groupShowUrl = `${process.env.REACT_APP_VENDORS_API_SERVER_BASE_URL}/groups/show/${id}`;
  const { data: dataGroup, loading: loadingGroup, fetchData: fetchGroupData } =
    useFetch(groupShowUrl, false);
  const { data: putResult, putData } = usePut();
  const { currentLangList, currentTenantId, currentCompanyId, currentBranchId, currentLangId } =
    useCurrent();
  const [formLang, setFormLang] = useState(currentLangId);
  const [errors, setErrors] = useState({});
  const [minDelayDone, setMinDelayDone] = useState(false);
  const [isFormReady, setIsFormReady] = useState(false);
  const [t] = useTranslation("global");

  useEffect(() => {
    setIsFormReady(false);
    setMinDelayDone(false);
    invalidateFetchCache(groupShowUrl);
    fetchGroupData();
    const timer = setTimeout(() => setMinDelayDone(true), 800);
    return () => clearTimeout(timer);
  }, [groupShowUrl, fetchGroupData]);

  const [groupName, setGroupName] = useState(langObjType());
  const [groupDesc, setGroupDesc] = useState(langObjType());
  const [isActive, setIsActive] = useState(true);

  const formValidate = () => {
    let errorObj = {};
    setErrors("");
    if (!groupName[currentLangId]) {
      errorObj = { ...errorObj, [`groupName.${currentLangId}`]: t("vendorGroups.groupNameRequired") };
      setFormLang(currentLangId);
    }

    if (Object.keys(errorObj).length !== 0) {
      setErrors(errorObj);
      return true;
    }

    return false;
  };
  const submitHandler = () => {
    if (formValidate()) return;

    const _data = {
      groupName: objLangTextHandler(groupName),
      groupDesc: objLangTextHandler(groupDesc),
      isActive,
      tenantId: currentTenantId,
      companyId: currentCompanyId,
      branchId: currentBranchId,
    };

    putData(`${process.env.REACT_APP_VENDORS_API_SERVER_BASE_URL}/groups/update/${id}`, _data);
  };

  useEffect(() => {
    if (putResult) {
      const groupsListUrl =
        currentTenantId && currentCompanyId && currentBranchId
          ? `${process.env.REACT_APP_VENDORS_API_SERVER_BASE_URL}/groups/${currentTenantId}/${currentCompanyId}/${currentBranchId}`
          : null;
      invalidateFetchCache(groupsListUrl);
      setMode("List");
    }
  }, [
    putResult,
    currentTenantId,
    currentCompanyId,
    currentBranchId,
    setMode,
  ]);

  useEffect(() => {
    if (dataGroup?.data) {
      setGroupName(LangArrayToObjKeyValue(dataGroup.data.groupName));
      setGroupDesc(LangArrayToObjKeyValue(dataGroup.data.groupDesc));
      setIsActive(Boolean(dataGroup.data.isActive));
      setIsFormReady(true);
    }
  }, [dataGroup]);

  return (
    <>
      <CardHeadeWithActions title={t("vendorGroups.editGroup")}>
        <MwButton inGroup={true} type="cancelBtn" onClick={() => setMode("List")}>
          {t("vendorGroups.manageVendorGroups")}
        </MwButton>
        <MwButton type="saveBtn" onClick={submitHandler} inGroup={true}>
          {t("vendorGroups.save")}
        </MwButton>
      </CardHeadeWithActions>
      {!isFormReady || loadingGroup || !minDelayDone ? (
        <div className="py-12">
          <MwSpinnerButton withLabel={false} isFullCenter={true} />
        </div>
      ) : (
        <GroupForm
          currentLangList={currentLangList}
          formLang={formLang}
          setFormLang={setFormLang}
          errors={errors}
          groupName={groupName}
          setGroupName={setGroupName}
          groupDesc={groupDesc}
          setGroupDesc={setGroupDesc}
          isActive={isActive}
          setIsActive={setIsActive}
        />
      )}
    </>
  );
};

export default EditGroup;
